exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-table-expand[data-v-1bcf05b0] {\n  font-size: 0;\n}\n.demo-table-expand label[data-v-1bcf05b0] {\n  width: 160px;\n  color: #99a9bf;\n}\n.demo-table-expand[data-v-1bcf05b0] {\n  margin-right: 2%;\n  margin-bottom: 0;\n  margin-left: 2%;\n  width: 96%;\n}\n.demo-table-expand.el-form--inline .el-form-item[data-v-1bcf05b0],\n.demo-table-expand.el-form--inline .el-form-item__content[data-v-1bcf05b0] {\n  word-break: break-word;\n}", ""]);

// exports
